import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/accessibility/fr/accessibility_EN.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Accessibility/accessibility__en-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-DE'].layout },
  seo: {
    title: 'Commitment To Web Accessibility | Lemonade Insurance',
    metaTitle: 'Commitment To Web Accessibility | Lemonade Insurance',
    description:
      "Lemonade is committed to making our website's content accessible and user-friendly to everyone. We take your feedback seriously as we evaluate ways to accommodate all of our customers and our overall accessibility policies.",
    ogImage: og.src,
  },
  MDXContent: content as DocumentTypes,
};
